/* eslint-disable */
import Vue from 'vue'
import Sticky from './sticky'


function plugin (Vue, options) {
    if (plugin.installed) {
      return
    }
  
    Vue.directive('sticky', Sticky)
}

export default plugin


// WEBPACK FOOTER //
// ./src/_fdp/core/directive/sticky/index.js